module.exports = __webpack_public_path__ + "static/media/wifi.e6f475ad.png";